import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const CookiesPolicy = () => {
  // Scroll to top when component mounts
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-8 max-w-4xl">
        <div className="mb-6">
          <Button
            variant="ghost"
            asChild
            className="text-legal-blue hover:text-legal-navy">
            <Link to="/" className="flex items-center gap-2">
              <ArrowLeft size={16} />
              Volver al Inicio
            </Link>
          </Button>
        </div>

        <h1 className="text-3xl md:text-4xl font-bold mb-6 text-legal-navy">
          Política de Cookies
        </h1>
        <p className="text-sm text-gray-500 mb-6">
          Última actualización: 7 de abril de 2025
        </p>

        <div className="prose max-w-none prose-headings:text-legal-navy prose-a:text-legal-blue">
          <p className="mb-6">
            Esta Política de Cookies explica cómo LegalAI ("nosotros", "nuestro"
            o "nuestra") utiliza cookies y tecnologías similares para
            reconocerle cuando visita nuestro sitio web.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            ¿Qué son las Cookies?
          </h2>
          <p className="mb-6">
            Las cookies son pequeños archivos de datos que se colocan en su
            computadora o dispositivo móvil cuando visita un sitio web. Las
            cookies son ampliamente utilizadas por los propietarios de sitios
            web para hacer que sus sitios funcionen, o funcionen de manera más
            eficiente, así como para proporcionar información de informes.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Cómo Utilizamos las Cookies
          </h2>
          <p className="mb-6">
            Utilizamos cookies por varios motivos, detallados a continuación:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">
              <strong>Cookies Necesarias:</strong> Estas cookies son esenciales
              para proporcionarle los servicios disponibles a través de nuestro
              sitio web y permitirle usar algunas de sus características.
            </li>
            <li className="mb-2">
              <strong>Cookies Analíticas:</strong> Estas cookies nos ayudan a
              analizar cómo los usuarios utilizan el sitio web, y a monitorear
              su rendimiento.
            </li>
            <li className="mb-2">
              <strong>Cookies de Funcionalidad:</strong> Estas cookies se
              utilizan para reconocerle cuando regresa a nuestro sitio web.
            </li>
            <li className="mb-2">
              <strong>Cookies de Publicidad:</strong> Estas cookies se utilizan
              para hacer que los mensajes publicitarios sean más relevantes para
              usted.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Control de las Cookies
          </h2>
          <p className="mb-6">
            Puede configurar su navegador para rechazar todas las cookies, o
            para indicar cuándo se está enviando una cookie. Sin embargo, si no
            acepta cookies, es posible que no pueda utilizar algunas partes de
            nuestro sitio web.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Cookies que Utilizamos
          </h2>
          <div className="mb-6">
            <h3 className="text-xl font-semibold mb-3">Cookies Necesarias:</h3>
            <ul className="list-disc pl-6 mb-4">
              <li>Sesión de usuario</li>
              <li>Autenticación</li>
              <li>Seguridad</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3">Cookies Analíticas:</h3>
            <ul className="list-disc pl-6 mb-4">
              <li>Google Analytics</li>
              <li>Análisis de uso</li>
              <li>Rendimiento del sitio</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3">
              Cookies de Funcionalidad:
            </h3>
            <ul className="list-disc pl-6 mb-4">
              <li>Preferencias de usuario</li>
              <li>Idioma</li>
              <li>Localización</li>
            </ul>
          </div>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Cambios en esta Política
          </h2>
          <p className="mb-6">
            Podemos actualizar esta Política de Cookies periódicamente. Le
            notificaremos cualquier cambio publicando la nueva Política de
            Cookies en esta página.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">Contáctenos</h2>
          <p className="mb-6">
            Si tiene alguna pregunta sobre nuestra Política de Cookies, por
            favor contáctenos:
          </p>
          <p>
            <strong>Correo electrónico:</strong>{" "}
            notificaciones@miasistentelegalia.com
            <br />
            <strong>Dirección:</strong> Medellin,Colombia
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CookiesPolicy;
